define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var ProductTypeModel = /** @class */ (function () {
        function ProductTypeModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            //ProviderId = ko.observable<number>();
            this.ProviderIds = ko.observable();
            this.ProviderName = ko.observable();
            this.Providers = ko.observableArray();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, ProductTypeModel.Mapping, self);
            }
        }
        ProductTypeModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new ProductTypeModel(options.data);
            }
        };
        return ProductTypeModel;
    }());
    return ProductTypeModel;
});
//# sourceMappingURL=ProductTypeModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/ProductTypeModel.js
// module id = 225
// module chunks = 2